import { initFadeIn } from "./namespace/fadeIn";
import { initPanelAnchor } from "./namespace/panelAnchor";

document.addEventListener("DOMContentLoaded", () => {
  initFadeIn();
  initPanelAnchor();
});
